// src/services/socket.js
// Conexión única y compartida a Socket.IO.
import { io } from 'socket.io-client'

// Extraer solo el origen (protocolo + host) de la URL de la API para evitar rutas anidadas como /api/socket.io
const getSocketUrl = () => {
    const apiUrl = import.meta.env.VITE_API_URL || window.location.origin
    try {
        const url = new URL(apiUrl, window.location.origin)
        return url.origin
    } catch {
        return window.location.origin
    }
}

const socket = io(getSocketUrl(), {
    withCredentials: true,
    autoConnect: false,
    path: '/maki-ot/socket.io',
    //transports: ['websocket', 'polling']
    transports: ['polling', 'websocket']
})

export default socket
